import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  message: null,
  status: null,
  commissionPlanFeeTemplate: null,
  commissionPlanFeeTemplates: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const commissionPlanFeeTemplateReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.COMMISSIONPLANFEETEMPLATE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING, message: null });
    }
    case actionTypes.COMMISSIONPLANFEETEMPLATE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.COMMISSIONPLANFEETEMPLATE_FAIL: {
      return updateState(state, { ...action.error, lastState: constants.STATE_FAIL });
    }
    case actionTypes.COMMISSIONPLANFEETEMPLATE_LISTRESET: {
      return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
    }
    default: {
      return state;
    }
  }
};

export default commissionPlanFeeTemplateReducer;
